// extracted by mini-css-extract-plugin
module.exports = {"frame":"IFrameView_frame__2qgGZ","container":"IFrameView_container__YYPzz","invisible":"IFrameView_invisible__1RuiI","spinner":"IFrameView_spinner__iLTdY"};